/* Layouts */
import Layout from '@layouts/layout.vue'
import AboutPage from '@pages/about-page.vue'
import ArticlePage from '@pages/article-page.vue'
import CollectionPage from '@pages/collection-page.vue'
import ContactPage from '@pages/contact-page.vue'
import HomePage from '@pages/home-page.vue'
import MerchItemPage from '@pages/merch-item-page.vue'
import LegalPage from '@pages/legal-page.vue'
import MerchPage from '@pages/merch-page.vue'
import ProductPage from '@pages/product-page.vue'
import ProductsPage from '@pages/products-page.vue'
import StoreLocatorPage from '@pages/store-locator-page.vue'
import ArticlesPage from '@pages/articles-page.vue'
import NotFoundPage from '@pages/not-found-page.vue'
import { createRouter, createWebHistory } from 'vue-router'

/* Routes */
const routes = [
	{
		path: '/',
		component: Layout,
		children: [
			{ path: '', name: 'home', component: HomePage },
			{ path: 'contact', name: 'contact', component: ContactPage },
			{ path: 'products', name: 'products', component: ProductsPage },
			{ path: 'product/:slug', name: 'product', component: ProductPage },
			{ path: 'merch', name: 'merch', component: MerchPage },
			{
				path: 'merch/collection/:slug',
				name: 'collection',
				component: CollectionPage,
			},
			{
				path: 'merch/product/:slug',
				name: 'merch-item',
				component: MerchItemPage,
			},
			{ path: 'about', name: 'about', component: AboutPage },
			{ path: 'article/:slug', name: 'article', component: ArticlePage },
			{ path: 'articles', name: 'articles', component: ArticlesPage },
			{
				path: 'store-locator',
				name: 'store-locator',
				component: StoreLocatorPage,
			},
			{ path: 'legal/:slug', name: 'legalPage', component: LegalPage },
		],
	},
	{ path: '/:pathMatch(.*)*', component: NotFoundPage },
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve({ left: 0, top: 0 })
			}, 25)
		})
	},
	history: createWebHistory(),
	routes,
})

export default router
